import React, { useState } from 'react';
import { Fragment } from "react";
import { Row, Col, Card, Carousel, CarouselItem } from "reactstrap";

const WhomWeServe = () => {
    /* eslint-disable */

    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const items1 = [
        {
            src: require("../../assets/extra/images/companies/png/Royal Enfield.png"),
            altText: 'ROYAL ENFIELD',
        },
        {
            src: require("../../assets/extra/images/companies/png/Hero.png"),
            altText: 'HERO',
        },
        {
            src: require("../../assets/extra/images/companies/png/Audi.png"),
            altText: 'AUDI',
        },
        {
            src: require("../../assets/extra/images/companies/png/Skoda.png"),
            altText: 'SKODA',
        },
        {
            src: require("../../assets/extra/images/companies/png/Suzuki.png"),
            altText: 'SUZUKI',
        },
        {
            src: require("../../assets/extra/images/companies/png/Bajaj.png"),
            altText: 'BAJAJ',
        },
        {
            src: require("../../assets/extra/images/companies/png/Porsche.png"),
            altText: 'PORSCHE',
        },
        {
            src: require("../../assets/extra/images/companies/png/Volkwagen.png"),
            altText: 'VOLKWAGEN',
        },
        {
            src: require("../../assets/extra/images/companies/png/Yamaha.png"),
            altText: 'YAMAHA',
        },
        {
            src: require("../../assets/extra/images/companies/png/Indian Motorcyle.png"),
            altText: 'INDIAN MOTORCYCLE',
        },
        {
            src: require("../../assets/extra/images/companies/png/Ampere.png"),
            altText: 'AMPERE',
        },
        {
            src: require("../../assets/extra/images/companies/png/Benelli.png"),
            altText: 'BENELLI',
        },
        {
            src: require("../../assets/extra/images/companies/png/Ducati.png"),
            altText: 'DUCATI',
        },
        {
            src: require("../../assets/extra/images/companies/png/Bounce.png"),
            altText: 'Bounce',
        },
        {
            src: require("../../assets/extra/images/companies/png/Altigreen.png"),
            altText: 'ALTIGREEN',
        },
        {
            src: require("../../assets/extra/images/companies/png/Mojo.png"),
            altText: 'MOJO',
        },
        {
            src: require("../../assets/extra/images/companies/png/JLR.png"),
            altText: 'JLR',
        },
        {
            src: require("../../assets/extra/images/companies/png/Piaggio.png"),
            altText: 'PIAGGIO',
        },
        {
            src: require("../../assets/extra/images/companies/png/Battre.png"),
            altText: 'BATTRE',
        },
        
        {
            src: require("../../assets/extra/images/companies/png/triumph.png"),
            altText: 'TRIUMPH',
        },
        {
            src: require("../../assets/extra/images/companies/png/Fiat.png"),
            altText: 'FIAT',
        },
        {
            src: require("../../assets/extra/images/companies/png/Citroen.png"),
            altText: 'CITROEN',
        },
        {
            src: require("../../assets/extra/images/companies/png/Revolt.png"),
            altText: 'REVOLT',
        },
        {
            src: require("../../assets/extra/images/companies/png/Jawa.png"),
            altText: 'JAWA',
        },
        

    ];
    const partnersPerPage = 8; // Display 8 partners per carousel page
    const totalPages = Math.ceil(items1.length / partnersPerPage);

    const next = () => {
        if (animating) return;
        const nextIndex = (activeIndex + 1) % totalPages;
        setActiveIndex(nextIndex);
    }

    const previous = () => {
        if (animating) return;
        const prevIndex = (activeIndex - 1 + totalPages) % totalPages;
        setActiveIndex(prevIndex);
    }

    const partnersCards = () => {
        const startIndex = activeIndex * partnersPerPage;
        const endIndex = Math.min(startIndex + partnersPerPage, items1.length);
        const visibleItems = items1.slice(startIndex, endIndex);

        return visibleItems.map((partner, i) => (
            <Col key={i} style={{ flex: '0 0 auto', maxWidth: '12.5%' }}> {/* Adjusted style to fit 8 cards in one row */}
                <Card className="o-hidden text-center">
                    <div className="chart-widget-top">
                        <Row className="card-body low-padding">
                            <Col xs="12">
                                <img className='img-fluid' style={{ maxHeight: '200px' }} src={partner.src} alt={partner.altText} />
                            </Col>
                        </Row>
                    </div>
                </Card>
            </Col>
        ));
    }

    return (
        <Fragment>
            <Row>
                <Col xl="11" className='mt-2 mb-1'>
                    <h4>{"Partners we proudly serve..."}</h4>
                </Col>
                <Col xl="1">
                    <Row>
                        <Col className='custom-right'>
                            <i className='fa fa-angle-left fa-2x icon-hover mr-3' onClick={previous}></i>
                            <i className='fa fa-angle-right fa-2x icon-hover ml-3' onClick={next}></i>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Carousel activeIndex={activeIndex} next={next} previous={previous}>
                    {[...Array(totalPages).keys()].map((pageIndex) => (
                        <CarouselItem
                            key={pageIndex}
                            onExiting={() => setAnimating(true)}
                            onExited={() => setAnimating(false)}
                        >
                            <Row style={{ display: 'flex', flexWrap: 'nowrap' }}>{partnersCards()}</Row> {/* Added style to keep partners in one line */}
                        </CarouselItem>
                    ))}
                </Carousel>
            </Row>
        </Fragment>
    )
}

export default WhomWeServe;
